import { ExclusiveLensProgramStatus, ExclusiveLensStatus } from "../../gql-generated/types";

interface UserEligibility {
    isUserEnrolledInLensPlus: boolean;
    isUserEligibleForLensPlus: boolean;
}

export const getUserEligibilityForLensPlus = (
    userEligibilityStatus: ExclusiveLensProgramStatus | undefined | null,
    acceptedLatestVersion: boolean,
): UserEligibility => {
    const isUserEligibleForLensPlus =
        userEligibilityStatus === ExclusiveLensProgramStatus.ExclusiveLensProgramStatusEligible;

    return {
        isUserEligibleForLensPlus,
        isUserEnrolledInLensPlus: isUserEligibleForLensPlus && acceptedLatestVersion,
    };
};

interface ExclusiveLensState {
    isExclusiveLens: boolean;
    isExclusiveLensPending: boolean;
}

export const getExclusiveLensState = (exclusiveLensStatus: ExclusiveLensStatus): ExclusiveLensState => {
    return {
        isExclusiveLens: exclusiveLensStatus === ExclusiveLensStatus.ExclusiveLensStatusExclusive,
        isExclusiveLensPending: exclusiveLensStatus === ExclusiveLensStatus.ExclusiveLensStatusEligible,
    };
};

interface VisibilityState {
    shouldRender: boolean;
    showValidationForUpdate: boolean;
    isExclusiveLensUpdate: boolean;
}

export const getComponentVisibility = (
    lens: object | undefined,
    isExclusiveLens: boolean,
    isExclusiveLensPending: boolean,
    isValid: boolean,
    lensCreatorPayoutEnrolled: boolean,
): VisibilityState => {
    const isExclusiveLensUpdate = lens && (isExclusiveLens || isExclusiveLensPending);
    const showValidationForUpdate = Boolean(isExclusiveLensUpdate && !isValid);

    const shouldRender =
        !lens || Boolean(isExclusiveLensUpdate) || showValidationForUpdate || lensCreatorPayoutEnrolled;

    return {
        shouldRender,
        showValidationForUpdate,
        isExclusiveLensUpdate: Boolean(isExclusiveLensUpdate),
    };
};

export const shouldDisableToggle = (
    disabled: boolean,
    lens: object | undefined,
    isExclusiveLens: boolean,
    isValid: boolean,
    canToggleExclusiveLens: boolean,
): boolean => {
    return disabled || Boolean(lens) || (isExclusiveLens ? false : !isValid) || !canToggleExclusiveLens;
};
